import router from "@/router"
import api from '@/api'

export default {
    async load({
        state,
        commit,
        dispatch
    }) {
        if (state.token) {
            api.defaults.headers.common['Authorization'] = state.token;
            dispatch('loadUser')
        }
        try {
            let website = await api("/website");
            commit("website_loaded", website);
            let stripe_key = await api("/stripe-pk")
            commit("stripe_pk_loaded", stripe_key)
        } catch (ex) {
            alert(ex.error)
        }

    },
    async countPortals({
        commit
    }) {
        //get users portal count.
        //call this after portal create/delete and its value will be used to check if we need to promp for upgrade and allow downgrade
        let count = await api(`/user/portals/count`)
        commit('counted_portals', count);
    },
    async loadBilling({
        commit
    }) {
        try {
            let self_serve_portal = await api(`/user/billing`);

            commit('loaded_billing', self_serve_portal.url)

        } catch (ex) {
            alert(ex.error)
        }
    },
    async loadUser({
        dispatch,
        commit
    }) {
        try {
            let user = await api({
                url: `/user`
            })
            commit('user_loaded', user)
            dispatch("load_notifications")
            dispatch("countPortals")
        } catch (ex) {
            commit("logout")
        }
    },
    async login(context, credentials) {
        let response = await api({
            url: `/login`,
            method: 'POST',
            data: credentials
        })
        if (!response.token) {
            throw "No token"
        }
        context.commit('set_token', response.token);
        await context.dispatch('loadUser')
        if (context.state.continue) {
            router.push(context.state.continue)
        } else {
            router.push("/portals")
        }
    },
    async google_login(context, access_token) {
        let response = await api({
            url: `/google-login`,
            method: 'POST',
            data: {
                access_token
            }
        })
        if (!response.token) {
            throw "No token"
        }
        context.commit('set_token', response.token);
        await context.dispatch('loadUser')
        if (context.state.continue) {
            router.push(context.state.continue)
        } else {
            router.push("/welcome")
        }
    },
    async facebook_login(context, access_token) {
        let response = await api({
            url: `/facebook-login`,
            method: 'POST',
            data: {
                access_token
            }
        })
        if (!response.token) {
            throw "No token"
        }
        context.commit('set_token', response.token);
        await context.dispatch('loadUser')
        if (context.state.continue) {
            router.push(context.state.continue)
        } else {
            router.push("/welcome")
        }
    },
    async load_notifications(context) {
        let notifications = await api({
            method: "GET",
            url: `/user/notifications`,
            params: {
                last_id: context.getters['notifications_sorted'][0] ? context.getters['notifications_sorted'][0].id : null
            }
        })
        context.commit('notifications_loaded', notifications)
    },
    async clear_notifications(context) {
        await api({
            method: "DELETE",
            url: "/user/notifications"
        })
        context.commit('notifications_cleared')
    },
    async seen_notifications(context) {
        await api({
            method: "PATCH",
            url: "/user/notifications"
        })
        context.commit('notifications_seen')
    },
    async acceptTerms(context) {
        await api({
            method: "PATCH",
            url: "/user/terms"
        })
        context.commit('accepted_terms')
    }
}